/**
 * Route for `maxbounty-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MaxbountyIntegrationViaApiPage } from "../features/maxbounty-integration-via-api/MaxbountyIntegrationViaApiPage";

export const maxbountyIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/maxbounty-integration-via-api",
	component: MaxbountyIntegrationViaApiPage,
});

export default maxbountyIntegrationViaApiRoute;
